import { ListingRecommendationItem } from 'common/api-types/recommendations';
import { DataTableSubRows } from 'common/components/cookbook/DataTable/DataTableSubRows';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { useUserLocale } from 'common/hooks/useUserLocale';
import { formatNumber } from 'common/utils/numberUtils';
import { RecommendationReasons } from 'features/selection-recommendations/common/RecommendationReasons/RecommendationReasons';

type Props = {
  parent: ListingRecommendationItem;
};

export const ListingRecommendationsSubList = ({ parent }: Props) => {
  const f = useFormatMessage();
  const locale = useUserLocale();

  return (
    <DataTableSubRows
      hideSelection={true}
      dataSource={parent.tiers ?? []}
      columns={[
        {
          id: 'tierName',
          header: '',
          width: 100,
          render: ({ record: { tierName } }) => tierName,
        },
        {
          id: 'expectedBusinessImpact',
          alignNameVertical: 'middle',
          alignContent: 'right',
          alignName: 'right',
          info: f(
            'selection_recommendations.delisting_recommendation_expected_business_impact_column_explanation',
          ),
          header: '',
          width: 150,
          render: () => null,
        },
        {
          id: 'reason',
          header: '',
          width: 'auto',
          render: ({ record: { reason } }) => (
            <RecommendationReasons reasons={reason ? [reason] : []} />
          ),
        },
        {
          id: 'revenueShare',
          header: '',
          alignNameVertical: 'middle',
          alignContent: 'right',
          alignName: 'right',
          width: 150,
          render: ({ record: { revenueShare } }) => `${formatNumber(locale, revenueShare, 2)}%`,
        },
        {
          id: 'globalRevenueShare',
          header: '',
          width: 150,
          alignContent: 'right',
          alignName: 'right',
          render: ({ record: { globalRevenueShare } }) => {
            if (!globalRevenueShare) {
              return '-';
            }

            return `${formatNumber(locale, globalRevenueShare, 2)}%`;
          },
        },
        {
          id: 'selectionCount',
          header: '',
          alignNameVertical: 'middle',
          alignContent: 'right',
          alignName: 'right',
          width: 150,
          render: ({ record: { selectionCount } }) => formatNumber(locale, selectionCount),
        },
        {
          id: 'gapVersusGlobalAverage',
          alignContent: 'right',
          alignName: 'right',
          width: 'auto',
          header: '',
          render: ({ record: { gapVersusGlobalAverage } }) =>
            formatNumber(locale, gapVersusGlobalAverage),
        },
        {
          id: 'gapVersusBestInClass',
          alignContent: 'right',
          alignName: 'right',
          width: 'auto',
          header: '',
          render: ({ record: { gapVersusBestInClass } }) =>
            formatNumber(locale, gapVersusBestInClass),
        },
      ]}
      parentRow={parent}
    />
  );
};
